const header = $('header');

const home3Slide = new Swiper('.home-3 .swiper', {
	loop: true,
	autoplay: {
		delay: 4500,
	},
	speed: 1000,
	spaceBetween: 30,
	observer: true,
	observeParents: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	navigation: {
		nextEl: ".home-3 .button-next",
		prevEl: ".home-3 .button-prev",
	},
	pagination: {
		el: '.home-3 .swiper-pagination',
		clickable: true,
	},
});

Fancybox.bind("[data-fancybox]", {
	showLoading: true,
	preload: true,
	infinite: false,
	parentEl: document.forms[0], // Element containing main structure
	mainClass: 'fancybox-wrapper', // Custom class name or multiple space-separated class names for the container
	dragToClose: false,
	// on: {
	// 	initLayout: (fancybox) => {
	// 	}
	// }
});

$('.popup input[type="button"]').on('click', function (e) {
	e.preventDefault();
	console.log('click');
	Fancybox.unbind('[data-fancybox]');
});

Fancybox.bind("a.popup-link", {
	showLoading: true,
	type: "iframe",
	preload: true,
});

Fancybox.bind('[data-fancybox="single"]', {
	groupAttr: false,
});

// const contactUsPage = document.getElementsByClassName('.contact-us-page');
// if (contactUsPage.length) {
// 	Fancybox.show([{
// 		src: "#contact-popup",
// 		type: "inline",
// 		preload: true,
// 	}]);
// }

$('.btn-close-fancybox').on('click', function () {
	Fancybox.close();
});

$('.btn-close-all-fancybox').on('click', function () {
	Fancybox.close();
});

const observer = lozad(".lozad", {
	threshold: 0.1,
	enableAutoReload: true,
	load: function (el) {
		el.src = el.getAttribute("data-src");
	},
});

// observer.observe();

// Handler for .ready() called
$(function () {
	NAVIGOS_APP.init();
	var menuMapping = $('header .main-menu').mapping({
		mobileWrapper: 'header .mobile-wrap',
		mobileMethod: 'appendTo',
		desktopWrapper: 'header .right',
		desktopMethod: 'prependTo',
		breakpoint: 1023
	});
	// padding-top main
	var mainPaddingTop = 0;
	// navLink.length > 0 ? mainPaddingTop = header.outerHeight() + navLink.outerHeight() : mainPaddingTop = header.outerHeight();
	let navLink = $('.nav-link');
	navLink.length > 0 ? mainPaddingTop = header.outerHeight() : mainPaddingTop = header.outerHeight();
	// set Height Banner
	$('main').css('padding-top', mainPaddingTop);
	let captionBanner = $('.banner-recruitment-section .caption, .top-banner .caption');
	var heightCaptionBanner = captionBanner.outerHeight() + 100;
	captionBanner.length > 0 ? captionBanner.parents('.image').css('height', heightCaptionBanner) : captionBanner.parents('.image').css('height', 'auto');
	setBackgroundElement();
	// form
	customSelect();
	// show form
	showFormReferralJob();
	// show slide
	home3ShowSlide();
	swiperInit();
	// tabActive();
	// slide circle
	toggleMeet();
	toggleCoverMeet();

	// page dashboard //
	// summernoteInit();
	// autoFormatDateInput();
	scrollToBox();
	addScriptScroll();
	ourServiceScroll();

	observer.observe();

	loadMoreJobs();
	suggestsearchTarget();
});

$(window).on("scroll", function () {
	NAVIGOS_APP.scrollActive();
})

var NAVIGOS_APP = {
	scrollActive: function () {
		let heightHeader = $("header").outerHeight();
		if ($(window).scrollTop() >= heightHeader) {
			$("header").addClass("active");
			$(".nav-link").addClass("active");
		} else {
			$(".nav-link").removeClass("active");
		}
		if ($(window).scrollTop() > 500) {
			$(".back-to-top").addClass("active");
		} else {
			$(".back-to-top").removeClass("active");
		}
	},
	toggleMenuMobile: () => {
		let btnMenu = $("header .menu-toggle"),
			mobileWrap = $("header .mobile-wrap"),
			searchBox = $('header .search-wrap');
		btnMenu.on("click", function () {
			$(this).toggleClass("active");
			mobileWrap.slideToggle();
			// close search box
			searchBox.slideUp();
		});
	},
	toggleSearchBox: () => {
		let btnSearch = $('header .btn-search'),
			btnSearchTop = $('header .btn-search'),
			btnClose = $('header .search-wrap .btn-close'),
			btnCloseTop = $('header .search-top .btn-close'),
			searchBox = $('header .search-wrap'),
			searchBoxTop = $('header .search-top .search'),
			inputTop = $('header .search-top .search input'),
			btnMenu = $("header .menu"),
			mobileWrap = $("header .mobile-wrap");
		btnSearch.on('click', function () {
			searchBox.slideToggle();

			// close mobile menu
			btnMenu.removeClass('active');
			mobileWrap.slideUp();
			disableScroll();
		});
		btnSearchTop.on('click', function () {
			searchBoxTop.addClass('active');

			// close mobile menu
			btnMenu.removeClass('active');
			disableScroll();
		});
		btnClose.on('click', function () {
			searchBox.slideToggle();
			enableScroll();
		});
		btnCloseTop.on('click', function () {
			searchBoxTop.removeClass('active');
			enableScroll();
		});
	},
	dropdownMenuMobile: () => {
		let dropdownEach = $('header li.has-dropdown');
		dropdownEach.each(function () {
			$(this).append('<span class="toggle-dropdown"></span>');
			$(this).find('.toggle-dropdown').on('click', function () {
				$(this).toggleClass('active').prev().slideToggle().parent().toggleClass('active');
				$(this).parent().siblings().removeClass('active').find('.dropdown-menu').slideUp().next().removeClass('active');
				$(this).parent().on('mouseleave', function () {
					var thisUI = $(this);
					$('html').on('click', function () {
						thisUI.children(".dropdown-menu").slideUp().next().removeClass('active');
						$('html').unbind('click');
					});
				});
			})
		});

	},
	checkLogin: () => {
		$('.before-login').length ? $('header .main-login .dropdown .dropdown-content').hide() : $('header .main-login .dropdown .dropdown-content').show()
	},
	backToTop: () => {
		$('.back-to-top').on('click', function () {
			$('html, body').animate({
				scrollTop: 0
			}, 0)
		})
	},
	init: () => {
		NAVIGOS_APP.scrollActive();
		NAVIGOS_APP.toggleMenuMobile();
		NAVIGOS_APP.checkLogin();
		NAVIGOS_APP.backToTop();
		// NAVIGOS_APP.toggleSearchBox();
		// NAVIGOS_APP.dropdownMenuMobile();
	}
}

function setBackgroundElement() {
	$('[setBackground]').each(function () {
		let background = $(this).attr('setBackground')
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center"
		});
	});
}

function customSelect() {
	if ($('.custom-select').length > 0) {
		$('.custom-select select[multiple]').each(function () {
			let dataPlaceholder = $(this).data('placeholder');
			let dataSelectAll = $(this).data('selectall');
			let dataMultiple = $(this).attr('multiple');
			let dataLimit = $(this).data('limit');
			let searchOption = $(this).attr('searchoption');
			let isSearch = typeof searchOption !== 'undefined' && searchOption !== false;
			let isSelectAll = typeof dataSelectAll !== 'undefined' && dataSelectAll !== false;
			let isMultiple = typeof dataMultiple !== 'undefined' && dataMultiple !== false;
			$(this).select2({
				tags: isMultiple,
				tokenSeparators: [',', ' '],
				closeOnSelect: !isMultiple,
				allowClear: true,
				theme: "classic",
				allowHtml: true,
				maximumSelectionLength: dataLimit,
				minimumResultsForSearch: true,
				dropdownParent: $(document.body)
			});
		});
	}
	if ($('.select-basic-single').length > 0) {
		$('.select-basic-single').each(function () {
			let dataPlaceholder = $(this).data('placeholder');
			$('.select-basic-single').select2({
				placeholder: dataPlaceholder,
				minimumResultsForSearch: Infinity,
			});
		});
	}
}

function showFormReferralJob() {
	$('.jobs-search-detail .btn-referral-job').on('click', function () {
		$(this).parent().next().toggleClass('active').parent().toggleClass('referral-job-active').next().slideToggle();
	});
	// close
	$('.jobs-search-detail .btn-close').on('click', function () {
		$(this).removeClass('active').parent().removeClass('referral-job-active').next().slideUp();
	});
}

function home3ShowSlide() {
	$('.testimonials .testimonial-wrap .row>*').on('click', function () {
		let dataSlide = $(this).data('slide');
		// $(`.home-3 .testimonial-slide[data-slide="${dataSlide}"]`).addClass('active').siblings().removeClass('active');
		$(`.home-3 .testimonial-slide`).addClass('active');
		$(this).parents('.hide-on').addClass('active');
		home3Slide.slideTo(dataSlide)
	});
	$(".home-3 .testimonials").on('mouseenter', function () {
		$(this).on("keydown", function (event) {
			if (event.keyCode == 27) {
				$('.home-3 .hide-on').removeClass('active');
				$('.home-3 .testimonial-slide').removeClass('active');
			}
		});
	}).on('mouseleave', function () {
		$('.home-3 .hide-on').removeClass('active');
		$('.home-3 .testimonial-slide').removeClass('active');
	});

	$(document).on('mouseup', function (e) {
		var container = $(".home-3 .testimonial-slide.active");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$(`.home-3 .testimonial-slide`).removeClass('active').siblings().removeClass('active');
			$(this).removeClass('active');
		}
	});
}

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

function swiperInit() {

	$(".swiper-advices-wrap .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("advices-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-advices-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-advices-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-advices-" + index);
		var swiper = new Swiper(".advices-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			slidesPerView: 1,
			navigation: {
				nextEl: ".btn-next-advices-" + index,
				prevEl: ".btn-prev-advices-" + index
			},
			pagination: {
				el: ".pagination-advices-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});

	$(".double-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("double-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-double-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-double-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-double-" + index);

		var swiper = new Swiper(".double-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				}
			},
			navigation: {
				nextEl: ".btn-next-double-" + index,
				prevEl: ".btn-prev-double-" + index
			},
			pagination: {
				el: ".pagination-double-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});
	$(".trinity-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("tri-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-tri-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-tri-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-tri-" + index);
		var swiper = new Swiper(".tri-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: ".btn-next-tri-" + index,
				prevEl: ".btn-prev-tri-" + index
			},
			pagination: {
				el: ".pagination-tri-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});
	$(".four-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-four" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-four-" + index);
		var swiper = new Swiper(".instance-four" + index, {
			speed: 1205,

			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
					autoplay: {
						delay: 3000,
						pauseOnMouseEnter: true,
					},
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			pagination: {
				el: ".pagination-four-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});
	$(".meet-item .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("meet-item-" + index);
		$this.find(".swiper-pagination").addClass("pagination-meet-" + index);
		var meetItemSlide = new Swiper(".meet-item-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			spaceBetween: 10,
			observer: true,
			observeParents: true,
			pagination: {
				el: ".pagination-meet-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});
	$(".information .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("information-swiper-" + index);
		$this.next().addClass("pagination-information-" + index);
		var informationSlide = new Swiper(".information-swiper-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			spaceBetween: 10,
			observer: true,
			observeParents: true,
			pagination: {
				el: ".pagination-information-" + index,
				type: 'bullets',
				clickable: true,
			},
		});
	});
}

function tabActive() {
	$(".contact-popup .tab-navigation a").on("click", function (e) {
		e.preventDefault();
		// $(this)
		// 	.parents(".tab-navigation")
		// 	.find("li")
		// 	.removeClass("active");
		// $(this)
		// 	.parents("li")
		// 	.addClass("active");

		var display = $(this).attr("data-type");
		console.log("🚀 ~ file: main.js:523 ~ display", display)
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
		$('html, body').animate({
			scrollTop: $(".contact-form-section").offset().top - header.height() - 54
		}, 0)
		Fancybox.close();
	});
}

const HTMLLoading = $('.box-meet-show .information-wrap').html();
function toggleMeet() {

	$('.meet-link-item a.ajaxlink').on('click', function () {
		let $this = $(this);
		let thisHTML = $this.parents('.meet-item').html();

		$('.box-meet-show .meet-item').html(thisHTML); // html left
		$('.box-meet-show .information-wrap').html(HTMLLoading); // html right

		$(this).parents('.meet-item').parent().hide().siblings().show().parent('.meet-wrap').prev().slideDown();

		let thisOffsetTop = $('.box-meet-show').offset().top
		let header = $('header').outerHeight(); 1
		window.scrollTo({
			top: thisOffsetTop - header,
			behavior: "smooth",
		});
	});

	$('.meet-wrap .meet-item').each(function (index) {
		let $this = $(this);
		$this.find('.cover-meet').on('click', function () {
			$this.parent().find('.swiper-slide:first-child() .meet-link-item:first-child() a').trigger('click');

			setTimeout(() => {
				let boxMeetItemSlide = new Swiper(".box-meet-show .meet-item .swiper", {
					speed: 1205,
					lazy: {
						loadPrevNext: true,
					},
					speed: 750,
					spaceBetween: 10,
					observer: true,
					observeParents: true,
					pagination: {
						el: ".box-meet-show .swiper-pagination",
						type: 'bullets',
						clickable: true,
					},
				});

				$(".box-meet-show .information .swiper").each(function (index, element) {
					let $this = $(this);
					$this.addClass("box-information-swiper-" + index);
					$this.next().addClass("box-pagination-information-" + index);
					let boxInformationSlide = new Swiper(".box-information-swiper-" + index, {
						speed: 1205,
						lazy: {
							loadPrevNext: true,
						},
						speed: 750,
						spaceBetween: 10,
						observer: true,
						observeParents: true,
						pagination: {
							el: ".box-pagination-information-" + index,
							type: 'bullets',
							clickable: true,
						},
					});

				});
				observer.observe();
			}, 1200);
		});
	});
}

function toggleCoverMeet() {
	$('.box-meet-show .meet-item .cover-meet').on('click', function () {
		$('.meet-wrap > *').filter(":hidden").show();
		$(this).parents('.box-meet-show').slideUp();
	})
}

// Add animation 
if ($('.animate').length > 0 && $(window).width() > 1279) {
	const callback = (entries) => {
		entries.forEach(
			(entry) => {
				if (entry.isIntersecting) {
					entry.target.style.animation = entry.target.dataset.animate;
					// console.log(entry.target.style.animation);
				}
				// else {
				// 	entry.target.style.animation="none";
				// }
			}
		);
	}
	let observer = new IntersectionObserver(callback);
	const animationItems = document.querySelectorAll('.animate');
	animationItems.forEach(item => {
		observer.observe(item)
	});
}

function autoFormatDateInput() {

	$('.form-group.form-date-format input').each(function () {
		let date = $(this)

		function checkValue(str, max) {
			if (str.charAt(0) !== '0' || str == '00') {
				var num = parseInt(str);
				if (isNaN(num) || num <= 0 || num > max) num = 1;
				str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
			};
			return str;
		};

		date.on('input', function (e) {
			this.type = 'text';
			var input = this.value;
			if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
			var values = input.split('/').map(function (v) {
				return v.replace(/\D/g, '')
			});
			if (values[0]) values[0] = checkValue(values[0], 31);
			if (values[1]) values[1] = checkValue(values[1], 12);
			var output = values.map(function (v, i) {
				return v.length == 2 && i < 2 ? v + '/' : v;
			});
			this.value = output.join('').substr(0, 14);
		});

		date.on('blur', function (e) {
			this.type = 'text';
			var input = this.value;
			var values = input.split('/').map(function (v, i) {
				return v.replace(/\D/g, '')
			});
			var output = '';

			if (values.length == 3) {
				var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
				var month = parseInt(values[0]) - 1;
				var day = parseInt(values[1]);
				var d = new Date(year, month, day);
				if (!isNaN(d)) {
					// document.getElementById('result').innerText = d.toString();
					var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
					output = dates.map(function (v) {
						v = v.toString();
						return v.length == 1 ? '0' + v : v;
					}).join('/');
				};
			};
			this.value = output;
		});
	})
}

$('.box-skills .form-skill .radio-group label').on('click', function () {
	let dataSkill = $(this).data('skill');
	$('.box-skills .form-skill .skill-wrap>label span').text(dataSkill + '/5');
	$(this).parent().removeClass('unchecked').addClass('checked').siblings().removeClass('checked').addClass('unchecked');
});

// show box email alerts setting
$('.btn-open-email-alerts').on('click', function () {
	$('.box-form-titlechange-email').fadeOut();
	$('.box-email-alerts-setting').fadeIn();
});

function scrollToBox() {
	let btnLink = $('.login-dashboard .profile-strenth a');
	btnLink.bind('click', function (event) {
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			let header = $('header').outerHeight();
			$('html, body').animate({
				scrollTop: $(hash).offset().top - header - 15
			}, 0);
		};
	});
}

function addScriptScroll() {
	if ($('body').hasClass('loginpage') || $('body').hasClass('recruitment-detail-page')) {
		let scriptSrc = "<script src=\"https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js\" charset=\"utf-8\"></script>",
			linkSrc = "<link href=\"https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.css\" rel=\"stylesheet\" charset=\"utf-8\"></link>";
		$('head').append(linkSrc);
		$('body').append(scriptSrc);
	}
	$('.loginpage .login-section .register .button a').on('click', function (e) {
		e.preventDefault();
		$.fancybox.open({
			src: '#form-register-popup',
			opts: {
				afterShow: function (instance, current) {
					$(".fancybox-is-open").appendTo("form");
				}
			},
			touch: false
		});
	});
	$('.jobs-search-detail .button-group .button .btn-apply').on('click', function (e) {
		e.preventDefault();
		$.fancybox.open({
			src: '#form-apply-popup',
			opts: {
				afterShow: function (instance, current) {
					$(".fancybox-is-open").appendTo("form");
				}
			},
			touch: false
		});
	});
	$('.loginpage #congratulations .button a').on('click', function (e) {
		e.preventDefault();
		$.fancybox.close({
			src: '#form-register-popup',
		});
	})

}

function ourServiceScroll() {
	let btn = $('.banner-home .button .btn');
	btn.on('click', function (e) {
		e.preventDefault();
		let thisOffsetTop = $('.home-1').offset().top
		let header = $('header').outerHeight();
		window.scrollTo({
			top: thisOffsetTop - header,
			behavior: "smooth",
		});
	})
}

function loadMoreJobs() {
	$('.load-more-jobs-ajax').on('click', function (e) {
		e.preventDefault();
		let jobsUrl = $(this).attr('href');
		$(this).addClass('opacity-0 ponter-events-none');
		$('.lds-ring').show();
		$.ajax({
			url: jobsUrl,
			data: {
				isajax: false
			},
			success: function (data) {
				let loadJobs = $(data).find('.jobs-list').html();
				let newUrlLoadMore = $(data).find('.load-more-jobs-ajax').attr('href');
				$('.lds-ring').hide();
				$('.jobs-list').append(loadJobs);
				if (newUrlLoadMore) {
					$('.load-more-jobs-ajax').attr('href', newUrlLoadMore).removeClass('opacity-0 ponter-events-none');
				} else {
					$('.load-more-jobs-ajax').remove();
				}
			}
		});
		return false;
	});
}

function suggestsearchTarget(){
	$('.banner-jobs-search-section .suggestsearch li').on('click', function(){
		let thisText = $(this).text();
		$('.banner-jobs-search-section .searchbox input').val(thisText);
		$('.banner-jobs-search-section .suggestsearch').remove();
	})
}
